import { useContext } from "react";
import PageTitle from "../../Components/Shared/PageTitle";
import { OpenContext } from "../../App";
import NotFound from "../Shared/NotFound";
import CheckDriverLoadsCount from "../../Components/Admin/CheckDriverLoadsCount";

const Home = () => {
  const { userRole, isLoading } = useContext(OpenContext);

  return (
    <div>
      {!isLoading && (
        <>
          {userRole === "admin" ? (
            <>
              {" "}
              <PageTitle title="Home" description="Admin will see Stats here" />
              <div>
                <div style={{ marginBottom: "10px" }}>
                  <CheckDriverLoadsCount />
                </div>
              </div>
            </>
          ) : (
            <NotFound />
          )}
        </>
      )}
    </div>
  );
};

export default Home;
